import axios from "../utils/axios";

// ==========================================
// Shipping Methods
// ==========================================

export const getShippingMethods = async (params) => {
    const response = await axios.get("/admin/shipping-methods", { params });
    return response.data;
};

export const getShippingMethodById = async (id) => {
    const response = await axios.get(`/admin/shipping-methods/${id}`);
    return response.data;
};

export const createShippingMethod = async (data) => {
    const response = await axios.post("/admin/shipping-methods", data);
    return response.data;
};

export const updateShippingMethod = async (id, data) => {
    const response = await axios.put(`/admin/shipping-methods/${id}`, data);
    return response.data;
};

export const deleteShippingMethod = async (id) => {
    const response = await axios.delete(`/admin/shipping-methods/${id}`);
    return response.data;
};

// ==========================================
// Shipping Zones
// ==========================================

export const getShippingZones = async (params) => {
    const response = await axios.get("/admin/shipping-zones", { params });
    return response.data;
};

export const getShippingZoneById = async (id) => {
    const response = await axios.get(`/admin/shipping-zones/${id}`);
    return response.data;
};

export const createShippingZone = async (data) => {
    const response = await axios.post("/admin/shipping-zones", data);
    return response.data;
};

export const updateShippingZone = async (id, data) => {
    const response = await axios.put(`/admin/shipping-zones/${id}`, data);
    return response.data;
};

export const deleteShippingZone = async (id) => {
    const response = await axios.delete(`/admin/shipping-zones/${id}`);
    return response.data;
};

export const syncShippingZoneLocations = async (id, data) => {
    const response = await axios.post(`/admin/shipping-zones/${id}/locations/sync`, data);
    return response.data;
};
